<template>
  <v-page page="surveyGroup" title="Survey Groups">
    <v-container class="px-0 mx-0 pt-1 mt-3">
      <v-layout class="px-0 mx-0 pt-1 mt-3"> </v-layout>
      <v-card class="px-1 mx-3 pt-1 mt-3 " v-if="!surveygroups.length">No data available</v-card>
      <v-card>
        <v-expansion-panels>
          <v-expansion-panel v-for=" ( sv, index ) in surveygroups" :key="index"  @click="fillContent(sv)" >
            <v-expansion-panel-header
              ><span class="font-weight-bold text-capitalize">{{
                sv.name
              }}</span></v-expansion-panel-header
            >
            <v-expansion-panel-content>
            <div class="d-flex text-xs-right mt-3 mr-1 mb-3" >
              <div class="flex-fill">
            <v-card class="px-1 mx-3 pt-1 mt-3 ">
              <v-card-text class="text-align-left">
                <dl>
                  <dt>Survey Group Id</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.survey_group_id}}</td>
                  </dd>
                  <dt>Created at</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.created_at ? new Date(sv.created_at).toLocaleString() : "-"}}</td>
                  </dd>
                  <dt>Created by</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.created_by ? sv.created_by : "-" }}</td>
                  </dd>
                  <dt>Updated at</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.updated_at ? new Date(sv.updated_at).toLocaleString() : "-"}}</td>
                  </dd>
                  <dt>Updated by</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.updated_by ? sv.updated_by : "-"}}</td>
                  </dd>
                  <dt>Count of respondents</dt>
                  <dd>
                    <td class="text-xs-left">{{ sv.count ? sv.count : "-"}}</td>
                  </dd>
                </dl>
              </v-card-text>
            </v-card >
              </div>
              <div class="flex-fill">
            <v-card class="px-1 mx-3 pt-1 mt-3">
              <v-card-text class="text-align-left">
                <dl>
                  <dt>Name</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.name}}</td>
                  </dd>
                  <dt> Survey Id</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.survey_id}}</td>
                  </dd>
                  <dt>Type</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.type ? surveymetadata.type : "-" }}</td>
                  </dd>
                  <dt>Date first response</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.first_response ? new Date(surveymetadata.first_response.first_response).toLocaleString() : "-"}}</td>
                  </dd>
                  <dt>Date last response</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.last_response ? new Date(surveymetadata.last_response).toLocaleString() : "-"}}</td>
                  </dd>
                  <dt>Qualtrics Id</dt>
                  <dd>
                    <td class="text-xs-left">{{ surveymetadata.qualtrics_id ?  surveymetadata.qualtrics_id : "-"}}</td>
                  </dd>
                </dl>
              </v-card-text>
            </v-card >
          </div>
          </div>
            <v-card class="px-1 mx-3 pt-1 mt-3" >
                <v-data-table :headers="headers" :items="questions" :items-per-page="5" >
                  <template v-slot:item="props">
                  <tr>
                    <td> {{ strLimit(props.item.questions,100)}} </td>
                    <td> {{ strLimit(props.item.options,100) }} </td>
                  </tr>
                </template>
                    <template slot="no-data">
                  <div class="text-xs-center py-2">
                      No results
                  </div>
                </template>
                </v-data-table>
            </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'

export default {
  name: 'SurveyResonse',
  components: {
    VPage
  },
  data () {
    return {
      placeholder: 'test',
      survey_meta_data: [],
      headers: [ { text: 'Questions', value: 'questions', sortable: true },
        { text: 'Responses', value: 'options', sortable: true }],
      results: [],
      surveygroups: [],
      questions: [ ],
      surveymetadata: ''
    }
  },
  mounted () {
    this.search()
  },
  computed: {},
  methods: {
    search () {
      this.loadMetaData()
    },
    loadMetaData () {
      this.loading = true
      var data = null
      this.$store
        .dispatch('surveys/fetchSurveyGroups', data)
        .then(response => {
          this.surveygroups = response
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve survey groups'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    fillContent (sv) {
      this.loadQuestions(sv.survey_group_id)
      this.loadSurveyMetaData(sv.survey_id)
    },
    loadQuestions (surveyGroupId) {
      this.loading = true
      var data = { 'sgid': surveyGroupId }
      this.$store
        .dispatch('surveys/fetchQuestionsAnswers', data)
        .then(response => {
          this.questions = response
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve questions and answers'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadSurveyMetaData (surveyId) {
      this.loading = true
      var data = { 'surveyId': surveyId }
      this.$store
        .dispatch('surveys/fetchSurveyData', data)
        .then(response => {
          this.surveymetadata = response[0]
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve survey meta data'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    strLimit (str, maxchar) {
      return str.length < maxchar ? str : str.substring(0, maxchar).concat('...')
    }

  }
}
</script>
<style lang="sass">
  .dt
    width: 30%
    margin: 0
  .dd
    width: 70%
    margin-left: auto
    white-space: pre
    word-wrap: break-word
    overflow-wrap: break-word
</style>
